/* Beyond Wash — front-end behaviour, Shopify port.
   The cart + add-to-cart layer now lives in Dawn's stack (product-form.js,
   cart.js, cart-drawer.js, global.js). This file keeps the site's own
   behaviours: mobile nav, announcement rotation, reveals, contact/newsletter
   forms, sticky buy visibility and the PDP gallery. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- toast
     Still used by the contact/newsletter form handler below. */
  var toastEl = $('[data-toast]'), toastMsg = $('[data-toast-msg]'), toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastMsg.textContent = msg;
    toastEl.hidden = false;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-on');
      setTimeout(function () { toastEl.hidden = true; }, 300);
    }, 2600);
  }

  /* ------------------------------------------------------------ mobilenav */
  var mnav = $('[data-mobilenav]');
  function openMenu() {
    if (!mnav) return;
    mnav.hidden = false;
    requestAnimationFrame(function () { mnav.classList.add('is-open'); });
    document.body.classList.add('is-locked');
    var b = $('[data-menu-open]'); if (b) b.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    if (!mnav) return;
    mnav.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    var b = $('[data-menu-open]'); if (b) b.setAttribute('aria-expanded', 'false');
    setTimeout(function () { mnav.hidden = true; }, 380);
  }

  /* ------------------------------------------------------- global clicks */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var hit = function (sel) { return t.closest ? t.closest(sel) : null; };

    if (hit('[data-menu-open]')) { openMenu(); return; }
    if (hit('[data-menu-close]')) { closeMenu(); return; }

    if (mnav && mnav.classList.contains('is-open') && hit('.mobilenav__list a')) closeMenu();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* ------------------------------------------------------------ announce */
  (function () {
    var wrap = $('[data-announce]');
    if (!wrap) return;
    var slides = $$('.announce__item', wrap);
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
    }
    function loop() { timer = setInterval(function () { go(i + 1); }, 4200); }
    loop();
    var prev = $('[data-announce-prev]', wrap), next = $('[data-announce-next]', wrap);
    if (prev) prev.addEventListener('click', function () { clearInterval(timer); go(i - 1); loop(); });
    if (next) next.addEventListener('click', function () { clearInterval(timer); go(i + 1); loop(); });
  })();

  /* -------------------------------------------------------------- reveal */
  (function () {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var delay = en.target.getAttribute('data-reveal-delay') || 0;
        setTimeout(function () { en.target.classList.add('is-in'); }, Number(delay));
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ------------------------------------------------------------- counters */
  (function () {
    var els = $$('[data-count-to]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target, to = parseFloat(el.getAttribute('data-count-to')), t0 = null;
        var dur = 1100;
        function tick(ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(to * eased).toString();
          if (k < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* --------------------------------------------------------------- forms
     Contact/newsletter forms stay front-end-only placeholders — wire these to
     a Shopify customer/contact form action or an app when ready. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.form, .newsletter')) return;
    if (form.closest('product-form') || form.matches('[data-type="add-to-cart-form"]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], .btn');
    if (btn) { btn.classList.add('is-busy'); btn.dataset.label = btn.textContent; btn.textContent = 'Sending…'; }
    setTimeout(function () {
      form.classList.add('is-sent');
      if (btn) { btn.classList.remove('is-busy'); btn.textContent = btn.dataset.label || 'Send'; }
      form.reset();
      toast(form.getAttribute('data-success') || 'Thanks — we’ll be in touch shortly.');
    }, 700);
  });

  /* ------------------------------------------------------------ masthead */
  (function () {
    var m = $('[data-masthead]');
    if (!m) return;
    window.addEventListener('scroll', function () {
      m.classList.toggle('is-stuck', window.scrollY > 12);
    }, { passive: true });
  })();

  /* --------------------------------------------------------- sticky buy */
  (function () {
    var bar = $('[data-stickybuy]');
    var anchor = $('[data-buybox]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(anchor);
  })();

  /* ------------------------------------------------------------ pdp gallery
     Thumbnail click swaps the main image; a swipe on the main image steps
     to the next/previous thumbnail. Markup: [data-gallery] > [data-gallery-main]
     (img) + [data-gallery-thumb] buttons carrying data-src. */
  (function () {
    var galleries = $$('[data-gallery]');
    if (!galleries.length) return;

    galleries.forEach(function (root) {
      var main = root.querySelector('[data-gallery-main]');
      var thumbs = $$('[data-gallery-thumb]', root);
      if (!main || !thumbs.length) return;

      var current = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (current < 0) current = 0;

      function show(index) {
        current = (index + thumbs.length) % thumbs.length;
        var thumb = thumbs[current];
        var src = thumb.getAttribute('data-src');
        if (src) main.src = src;
        var img = thumb.querySelector('img');
        if (img) main.alt = img.alt;
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { show(i); });
      });

      /* swipe: left = next, right = previous */
      var startX = null;
      main.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        show(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    });
  })();

  /* ---------------------------------------------------------------- reels */
  (function () {
    var rail = $('[data-reel-rail]');
    var lb = $('[data-lightbox]');
    var data = window.BW_REELS || [];
    if (!rail) return;

    /* rail paging */
    function step() {
      var card = rail.querySelector('.reel');
      if (!card) return 280;
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 20;
      return (card.getBoundingClientRect().width + gap) * 2;
    }
    function syncNav() {
      var prev = $('[data-reel-prev]'), next = $('[data-reel-next]');
      if (!prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }
    rail.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);
    window.addEventListener('load', syncNav);
    syncNav();
    setTimeout(syncNav, 400);
    var pv = $('[data-reel-prev]'), nx = $('[data-reel-next]');
    if (pv) pv.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    /* muted in-view preview, only for reels that have a real video */
    var vids = $$('[data-reel-preview]', rail);
    if (vids.length && 'IntersectionObserver' in window) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) {
              if (v.preload === 'none') v.preload = 'metadata';
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { threshold: 0.6 });
        vids.forEach(function (v) { vio.observe(v); });
      }
    }

    /* lightbox */
    if (!lb) return;
    var stage = $('[data-lb-stage]', lb);
    var elTitle = $('[data-lb-title]', lb);
    var elCap = $('[data-lb-caption]', lb);
    var elBy = $('[data-lb-by]', lb);
    var current = 0;
    var lastFocus = null;

    function render(i) {
      var r = data[i];
      if (!r) return;
      current = i;
      stage.innerHTML = r.src
        ? '<video controls autoplay playsinline preload="auto" poster="' + r.poster + '"><source src="' + r.src + '" type="video/mp4"></video>'
        : '<img src="' + r.poster + '" alt="">';
      lb.classList.toggle('is-soon', !r.src);
      elTitle.textContent = r.title;
      elCap.textContent = r.caption;
      elBy.textContent = r.src
        ? r.creator + ' · ' + r.city
        : 'Filming with ' + r.creator + ' in ' + r.city + '. This reel is coming soon.';
    }

    function open(i) {
      lastFocus = document.activeElement;
      render(i);
      lb.hidden = false;
      requestAnimationFrame(function () { lb.classList.add('is-open'); });
      document.body.classList.add('is-locked');
      var close = $('[data-lb-close]', lb);
      if (close) close.focus();
    }
    function close() {
      lb.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      setTimeout(function () {
        lb.hidden = true;
        stage.innerHTML = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 320);
    }
    function move(d) { render((current + d + data.length) % data.length); }

    document.addEventListener('click', function (e) {
      var t = e.target;
      var openBtn = t.closest && t.closest('[data-reel-open]');
      if (openBtn) { e.preventDefault(); open(parseInt(openBtn.getAttribute('data-reel-open'), 10) || 0); return; }
      if (t.closest && t.closest('[data-lb-close]')) { close(); return; }
      if (t.closest && t.closest('[data-lb-prev]')) { move(-1); return; }
      if (t.closest && t.closest('[data-lb-next]')) { move(1); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowLeft') { move(-1); return; }
      if (e.key === 'ArrowRight') { move(1); return; }
      if (e.key === 'Tab') {
        var f = $$('button, video, [href]', lb).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  /* ------------------------------------------------ bottle life calculator */
  (function () {
    var roots = $$('[data-blc]');
    if (!roots.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      /* the two assumptions travel on the section, so markup and script agree */
      var KG_DAY = parseFloat(root.getAttribute('data-blc-kg-day')) || 0.5;
      var KG_ML = parseFloat(root.getAttribute('data-blc-kg-ml')) || 3;

      var famIn = root.querySelector('[data-blc-input="family"]');
      var dayIn = root.querySelector('[data-blc-input="days"]');
      var famOut = root.querySelector('[data-blc-out="family"]');
      var dayOut = root.querySelector('[data-blc-out="days"]');
      var kgEl = root.querySelector('[data-blc-kg]');
      var ratioEl = root.querySelector('[data-blc-ratio]');
      var live = root.querySelector('[data-blc-live]');
      var avatars = $$('.blc__avatar', root);
      var rows = $$('[data-blc-result]', root);
      if (!famIn || !dayIn || !rows.length) return;

      var heroRow = rows.filter(function (r) { return r.getAttribute('data-blc-role') === 'hero'; })[0] || rows[0];
      var secondaryRow = rows.filter(function (r) { return r !== heroRow; })[0] || heroRow;

      function daysFor(family, usageDays, ml) {
        var mlPerUsageDay = (family * KG_DAY) / KG_ML;
        return Math.round((ml / mlPerUsageDay) * (30 / usageDays));
      }

      /* count-up, re-run on every change; the last frame always lands on the exact value */
      function countTo(el, to) {
        if (!el) return;
        var from = parseInt(el.textContent, 10);
        if (isNaN(from)) from = 0;
        if (el._blcTimer) cancelAnimationFrame(el._blcTimer);
        if (reduce || from === to) { el.textContent = to; return; }
        var t0 = null, dur = 420;
        function tick(ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(from + (to - from) * eased);
          if (k < 1) el._blcTimer = requestAnimationFrame(tick);
          else el.textContent = to;
        }
        el._blcTimer = requestAnimationFrame(tick);
      }

      function setFill(input) {
        var min = +input.min, max = +input.max;
        input.style.setProperty('--fill', ((input.value - min) / (max - min)) * 100 + '%');
      }

      var liveTimer;
      function paintCalc() {
        var family = +famIn.value;
        var usageDays = +dayIn.value;

        famIn.setAttribute('aria-valuenow', family);
        famIn.setAttribute('aria-valuetext', family + (family === 1 ? ' person' : ' people'));
        dayIn.setAttribute('aria-valuenow', usageDays);
        dayIn.setAttribute('aria-valuetext', usageDays + (usageDays === 1 ? ' day a month' : ' days a month'));
        setFill(famIn); setFill(dayIn);
        if (famOut) famOut.textContent = family;
        if (dayOut) dayOut.textContent = usageDays;

        avatars.forEach(function (a, i) { a.classList.toggle('is-on', i < family); });

        var heroMl = parseFloat(heroRow.getAttribute('data-blc-ml'));
        var heroDays = daysFor(family, usageDays, heroMl);

        rows.forEach(function (row) {
          var ml = parseFloat(row.getAttribute('data-blc-ml'));
          var d = row === heroRow ? heroDays : daysFor(family, usageDays, ml);
          var pct = row === heroRow ? 100 : Math.round((d / heroDays) * 100);
          countTo(row.querySelector('[data-blc-days]'), d);
          var bar = row.querySelector('[data-blc-bar]');
          if (bar) bar.style.width = pct + '%';
          row._blcDays = d;
        });

        var secondaryDays = secondaryRow._blcDays || heroDays;
        var kgPerMonth = Math.round(family * KG_DAY * usageDays);
        var ratio = (heroDays / secondaryDays).toFixed(1);

        if (kgEl) kgEl.textContent = kgPerMonth;
        if (ratioEl) ratioEl.textContent = ratio;

        /* one settled announcement rather than a stream of partial ones */
        if (live) {
          clearTimeout(liveTimer);
          liveTimer = setTimeout(function () {
            live.textContent =
              'For ' + family + (family === 1 ? ' person' : ' people') + ' using it ' +
              usageDays + (usageDays === 1 ? ' day' : ' days') + ' a month: the ' +
              (heroRow.getAttribute('data-blc-label') || 'larger') + ' bottle lasts about ' +
              heroDays + ' days, the ' + (secondaryRow.getAttribute('data-blc-label') || 'smaller') +
              ' bottle about ' + secondaryDays + ' days. ' +
              'That is roughly ' + kgPerMonth + ' kilos of produce a month.';
          }, 500);
        }
      }

      famIn.addEventListener('input', paintCalc);
      dayIn.addEventListener('input', paintCalc);
      paintCalc();
    });
  })();
})();
